import http from "../base/http.service";
import { AxiosRequestConfig } from "axios";

export interface DynamicChoiceDto {
  id?: number;
  text: string;
}

export interface DynamicQuestionDto {
  id?: number;
  text: string;
  question_type: "text" | "single_choice" | "multiple_choice" | "rating";
  order: number;
  choices?: DynamicChoiceDto[];
}

export interface DynamicSurveyDto {
  id?: number;
  title: string;
  description?: string;
  is_active: boolean;
  created_at?: string;
  questions?: DynamicQuestionDto[];
  has_submitted?: boolean;
}

export interface DynamicAnswerSubmitDto {
  question_id: number;
  text_answer?: string;
  selected_choices?: number[];
  rating_answer?: number;
}

export interface DynamicResponseSubmitDto {
  answers: DynamicAnswerSubmitDto[];
}

export interface SurveyAnalysisQuestion {
  id: number;
  text: string;
  question_type: "text" | "single_choice" | "multiple_choice" | "rating";
  order: number;
  results: any; // dynamic based on question_type
}

export interface SurveyAnalysisDto {
  survey_title: string;
  survey_description?: string;
  total_responses: number;
  questions: SurveyAnalysisQuestion[];
}

const dynamicSurveyService = {
  getSurveys(config?: AxiosRequestConfig) {
    return http.get<DynamicSurveyDto[]>("forms/api/surveys", config);
  },

  getSurveyDetail(id: number, config?: AxiosRequestConfig) {
    return http.get<DynamicSurveyDto>(`forms/api/surveys/${id}`, config);
  },

  createSurvey(dto: DynamicSurveyDto, config?: AxiosRequestConfig) {
    return http.post<DynamicSurveyDto>("forms/api/surveys", dto, config);
  },

  updateSurvey(id: number, dto: Partial<DynamicSurveyDto>, config?: AxiosRequestConfig) {
    return http.put<DynamicSurveyDto>(`forms/api/surveys/${id}`, dto, config);
  },

  deleteSurvey(id: number, config?: AxiosRequestConfig) {
    return http.delete<string>(`forms/api/surveys/${id}`, config);
  },

  submitSurveyResponse(surveyId: number, dto: DynamicResponseSubmitDto, config?: AxiosRequestConfig) {
    return http.post<string>(`forms/api/surveys/${surveyId}/submit`, dto, config);
  },

  checkSurveySubmission(surveyId: number, config?: AxiosRequestConfig) {
    return http.get<{ has_submitted: boolean }>(`forms/api/surveys/${surveyId}/check-submission`, config);
  },

  getSurveyAnalysis(surveyId: number, config?: AxiosRequestConfig) {
    return http.get<SurveyAnalysisDto>(`forms/api/surveys/${surveyId}/analysis`, config);
  }
};

export default dynamicSurveyService;
